import React, { useState, useEffect } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  PageSubTitle,
  Loading,
  RadioButton,
  Text
} from 'components/common/Elements/Elements';
import { LineNew } from 'components/common/charts/charts';
import { Legend } from 'components/common/charts/parts/parts';

import {
  monthesPeriods,
  monthPerLabel
} from 'components/common/charts/helpers/config/filtersConfig';
import useWindowSize from 'hooks/useWindowSize';
import { scoreOverTimeConfig } from '../../../helpers/configurates';

import classes from './ScoreOverTime.module.scss';

const ScoreOverTime = ({ data, loader }) => {
  const [period, setPeriod] = useState('6M');
  const [conf, setConf] = useState(scoreOverTimeConfig);

  const [show, setShow] = useState(true);
  const [oldSize, setOldSize] = useState(0);

  const size = useWindowSize();
  const length = data.length;

  useEffect(() => {
    let timer = null;
    if (oldSize > size.width || (size.width >= 1441 && oldSize < 1441)) {
      setShow(false);
      setOldSize(size.width);
      timer = setTimeout(() => setShow(true), 500);
    } else setOldSize(size.width);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [size.width]);

  const toCut = () => {
    //lengs of period
    if (period === '6M') {
      return 6;
    } else if (period === '3M') {
      return 3;
    } else {
      return 2;
    }
  };

  const formatDate = //cut date with get period
    period !== '1Y' ? data.slice(Math.max(length - toCut(), 0)) : [...data];

  const handlePeriod = e => {
    if (e.target.value !== period) {
      setPeriod(e.target.value);
    }
  };

  if (!loader) {
    return <Loading />;
  }

  return (
    <section className={classes.box}>
      <PageSubTitle hiden title="CSAT Score/Rating over time chart" size={3} />
      <div className={classes.info}>
        <div className={classes.header}>
          {data[length - 1].ticket && data[length - 1].chart && (
            <>
              <Text size={6} weight="b" className={classes.title}>
                Tickets:
              </Text>
              <Text size={6} weight="b" className={classes.text}>
                {data[length - 1].ticket}/10
              </Text>
              <Text size={6} weight="b" className={classes.title}>
                Chats
              </Text>
              <Text size={6} weight="b" className={classes.text}>
                {data[length - 1].chat}/10
              </Text>
            </>
          )}
        </div>
        <RadioButton
          handleUnit={handlePeriod}
          unit={period}
          units={monthesPeriods}
          name="Period"
          type="c"
          unitsLabel={monthPerLabel}
        />
      </div>
      {show ? <LineNew data={formatDate} config={conf} /> : <Loading />}
      <Legend config={conf} setConfig={setConf} />
    </section>
  );
};

ScoreOverTime.propTypes = {
  data: PropTypes.arrayOf(object),
  loader: PropTypes.bool
};

export default ScoreOverTime;
